<template>
  <header class="header">
    <nav class="navbar navbar-expand-lg fixed-top bg-dark text-white px-lg-5">
      <div class="container-fluid">
        <button class="navbar-toggler" type="button" @click="toggleNavbar" aria-label="Toggle navigation">
          <span class="ti-menu"></span>
        </button>

        <div class="collapse navbar-collapse" :class="{ show: navbarOpen }">
          <ul class="navbar-nav ms-auto align-items-center">
            <!-- SPA маршруты -->
            <li class="nav-item" v-for="item in spaMenuItems" :key="item.to">
              <RouterLink
                class="nav-link text-white"
                :to="item.to"
                style="min-width: 110px; text-align: center;"
              >
                {{ $t(item.label) }}
              </RouterLink>
            </li>

            <!-- SSR Devise -->
            <li class="nav-item">
              <a href="/accounts/sign_in" class="nav-link text-white" style="min-width: 110px; text-align: center;">
                {{ $t('menu.login') }}
              </a>
            </li>
            <li class="nav-item">
              <a href="/accounts/sign_up" class="nav-link text-white" style="min-width: 110px; text-align: center;">
                {{ $t('menu.registration') }}
              </a>
            </li>

            <!-- ЯЗЫК -->
            <li class="nav-item ms-2">
              <select
                v-model="languageStore.locale"
                @change="changeLanguage"
                class="form-select form-select-sm bg-dark text-white border-0"
              >
                <option value="en">🇬🇧 EN</option>
                <option value="de">🇩🇪 DE</option>
                <option value="ro">🇷🇴 RO</option>
                <option value="ru">🇷🇺 RU</option>
                <option value="tr">🇹🇷 TR</option>
              </select>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useLanguageStore } from '@/stores/languageStore'

const languageStore = useLanguageStore()
const { locale } = useI18n()

const navbarOpen = ref(false)
const toggleNavbar = () => {
  navbarOpen.value = !navbarOpen.value
}

const changeLanguage = () => {
  locale.value = languageStore.locale
  languageStore.setLocale(languageStore.locale)
}

// Только SPA-маршруты — Devise убраны отсюда
const spaMenuItems = [
  { to: '/', label: 'menu.home' },
  { to: '/public/developers', label: 'menu.developers' },
  { to: '/public/agencies', label: 'menu.agencies' },
  { to: '/public/properties', label: 'menu.properties' },
]
</script>
